import { Button } from 'antd';
import React from 'react';

export default function ErrorPage() {
  return (
    <div className="flex w-full h-screen">
      <div className="m-auto">
        <h3>Something went wrong</h3>
        <div className="flex w-full justify-center">
          <Button
            type="primary"
            onClick={() => window.location.replace('/')}
            size="large"
            className="mt-md"
          >
            Restart
          </Button>
        </div>
      </div>
    </div>
  );
}
